var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 22V12.398C7 11.33 7 10.796 7.245 10.348C7.489 9.89999 7.938 9.61099 8.837 9.03299L10.919 7.69499C11.444 7.35799 11.706 7.18899 12 7.18899C12.294 7.18899 12.556 7.35799 13.082 7.69499L15.163 9.03299C16.062 9.61099 16.511 9.89999 16.755 10.348C17 10.796 17 11.33 17 12.398V22M12 13H12.009M21 22V16.162C21 13.871 19.74 13.685 17 13M3 22V16.162C3 13.871 4.26 13.685 7 13M2 22H22M12 22V18M12 6.99999V4.98199M12 4.98199V2.96999C12 2.49599 12 2.25899 12.146 2.11199C12.606 1.64899 14.5 2.74299 15.22 3.18699C15.828 3.56099 16 4.30899 16 4.98199H12Z",
    stroke: "#00ADEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/categoryIcon.d31c1f3e260e1a9ae1bed354f23312c2.svg";
export { ForwardRef as ReactComponent };